import { lazy } from 'react';
import { Route } from 'react-router-dom';

const List = lazy(() => import('./index'));
const Update = lazy(() => import('./update'));

export default function FactorRoutes() {
  return (
    <Route path="factor">
      <Route index element={<List />} />
      <Route path=":id/update" element={<Update />} />
    </Route>
  );
}
